import type { ActionContext, ActionFunction, LegacyDispatchFunction } from 'satcheljs/lib/legacy';
import { getSignalNameFromActionName, isActionToBeTracked } from '../utils/actionToSignalMapping';
import { signalWorkflowEvent } from 'mini-workflow-manager';

/**
 * This legacy middleware intercepts all legacy satchel actions only and fires "signal" calls on AppContext instance
 * which in turn logs PerformanceDatapoint and tracks user's workflows.
 */
export const satchelLegacyWorkflowTrackerMiddleware = (
    next: LegacyDispatchFunction,
    action: ActionFunction,
    actionType: string,
    args: IArguments,
    actionContext: ActionContext
): void => {
    // Since this middleware is called for every legacy satchel action and we want to track only a
    // few actions that we're interested in, we need to check if the action is to be tracked or not.
    if (isActionToBeTracked(actionType)) {
        const { dp, datapoint } = actionContext ?? {};
        const { customData } = dp ?? datapoint ?? {};
        const data = typeof customData === 'function' ? customData() : customData;

        signalWorkflowEvent(getSignalNameFromActionName(actionType) || '', data, {
            isCore: true,
        });
    }

    // Pass the control to next middleware in the sequence.
    next(action, actionType, args, actionContext);
};
